<script lang="ts">
import {defineComponent} from 'vue'
import FloatLabel from 'primevue/floatlabel'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Button from 'primevue/button'
import {useAuthStore} from '@/stores/auth.store'
import Select from 'primevue/select'
import Dialog from 'primevue/dialog'
import LoginContainer from "@/components/Global/Layout/LoginContainer.vue";

export default defineComponent({
  name: 'LoginView',
  components: {
    LoginContainer,
    FloatLabel,
    InputText,
    Password,
    Button,
    Select,
    Dialog
  },
  data() {
    return {
      entityTypeOptions:  ["student"/*, "teacher"*/, "contact_person"] as string[],
      email: '' as string,
      password: '' as string,
      isLoading: false as boolean,
      entityType: this.$route.name == 'admin_login' ? 'admin' : localStorage.getItem('auth_entity_type') || 'student',
      tutorialDialogVisible: false as boolean
    }
  },
  methods: {
    submit: function(e: SubmitEvent){
      const authStore = useAuthStore()
      this.isLoading = true
      authStore.login(this.email, this.password, this.entityType)
          .then(() => {
            this.isLoading = false
            switch (authStore.getUserType) {
              case "student":
                this.$router.push({name: "student_dashboard"})
                break;

              case "contact_person":
                this.$router.push({name: "contact_person_managed_students"})
                break;

              default:
                this.$router.push({name: this.entityType+"_dashboard"})
            }
          })
          .catch((error: any) => {
            this.isLoading = false
            this.$toast.add({severity:'error', summary:this.$t('login_view.messages.error_title'), detail: error, life: 5000})
          })
      e.preventDefault()
      e.stopPropagation()
    },
    getEntityTypeLabel(value: string){
      return this.$t("login_view.messages.entity_type_label."+value)
    },
    entityChange(value: string){
      localStorage.setItem('auth_entity_type', value)
    }
  },
  computed: {
    tutorialVideoUrl(): string {
      const url = this.$t('login_view.view.tutorial_video_url') as string
      return url && url !== 'login_view.view.tutorial_video_url' ? url : ''
    }
  }
});
</script>

<template>
  <LoginContainer :isLoading="isLoading">
    <form @submit="submit">
      <FloatLabel>
        <InputText id="email" v-model="email" fluid type="email" required />
        <label for="email">{{ $t('login_view.view.email_label') }}</label>
      </FloatLabel>
      <FloatLabel>
        <Password id="password" v-model="password" fluid :feedback="false" required />
        <label for="password">{{ $t('login_view.view.password_label') }}</label>
      </FloatLabel>
      <FloatLabel v-if="entityType != 'admin'">
        <Select id="entity_type" :options="entityTypeOptions" :optionLabel="getEntityTypeLabel"
                @update:modelValue="entityChange" v-model="entityType" fluid />
        <label for="entity_type">{{ $t('login_view.view.entity_type_label') }}</label>
      </FloatLabel>
      <Button :label="$t('login_view.view.login_button')" fluid type="submit" />
      <div class="login_actions" v-if="entityType != 'admin'">
        <RouterLink id="forgot_btn" :to="{name: 'password_reset'}">
          <Button :label="$t('login_view.view.forgot_password')" fluid severity="info" outlined icon="pi pi-question-circle" />
        </RouterLink>
        <Button v-if="tutorialVideoUrl" class="tutorial_btn" type="button" :label="$t('login_view.view.tutorial_button')" fluid severity="secondary" icon="pi pi-video" @click="tutorialDialogVisible = true" />
      </div>
    </form>
    <div class="register_container" v-if="entityType != 'admin'">
      <p>{{ $t('login_view.view.no_account_txt') }}</p>
      <small>{{ $t('login_view.view.no_account_txt_create_info') }}</small>
      <RouterLink :to="{name: 'password_reset', params: { create: '1' }}"><Button :label="$t('login_view.view.create_password_button')" fluid style="margin-bottom: 1rem" /></RouterLink>
<!--      <small>{{ $t('login_view.view.no_account_txt_register_info') }}</small>-->
<!--      <RouterLink :to="{name: 'student_register'}"><Button :label="$t('login_view.view.register_button')" fluid /></RouterLink>-->
    </div>
    <Dialog v-if="tutorialVideoUrl && entityType != 'admin'" v-model:visible="tutorialDialogVisible" modal closeOnEscape class="tutorial_dialog"
            :style="{ width: 'min(90vw, 720px)' }" dismissableMask>
      <template #header>&nbsp;</template>
      <div class="tutorial_iframe_wrapper">
        <iframe :src="tutorialVideoUrl"
                title="Tutoriel vidéo"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen />
      </div>
    </Dialog>
  </LoginContainer>
</template>

<style scoped lang="scss">
@use "@/styles/global/variables.scss" as *;
:deep(.p-floatlabel){
  margin-bottom: 2rem;
}
p {
  margin-bottom: 1rem;
}
a {
  font-size: 0.9rem;
  text-decoration: none;
  //margin-bottom: 1rem;
  display: block;
}
a:last-child:not(:first-child) {
  margin-top: 1rem;
  margin-bottom: 0;
}
.or_txt{
  display: block;
  margin-bottom: 1rem;
  text-align: center;
}
.login_actions {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.register_container {
  margin-top: 2.5rem;
}
small{
  color: $low_information_color;
  margin-bottom: 0.5rem;
  display: block;
}
.tutorial_iframe_wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 0.5rem;
}
.tutorial_iframe_wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
